export type RoleResponse = {
  id: number
  name: string
  description: string | null
  scope: string
  organization_id: number | null
}

export type SiteResponse = {
  id: number
  name: string
  slug: string
  is_active: boolean
  organization_id: number
}

export type UserResponse = {
  id: number
  email: string
  full_name: string | null
  is_active: boolean
  is_superuser: boolean
  is_verified: boolean
  organization_id: number
  role: RoleResponse | null
  sites: SiteResponse[]
  default_site_id: number | null
}

export type AuthRole = {
  id: number
  name: string
  description: string | null
  scope: string
  organizationId: number | null
}

export type AuthSite = {
  id: number
  name: string
  slug: string
  isActive: boolean
  organizationId: number
}

export type AuthUser = {
  id: number
  email: string
  fullName: string | null
  isActive: boolean
  isSuperuser: boolean
  isVerified: boolean
  organizationId: number
  role: AuthRole | null
  sites: AuthSite[]
  defaultSiteId: number | null
}

export const transformAuthUser = (payload: UserResponse): AuthUser => ({
  id: payload.id,
  email: payload.email,
  fullName: payload.full_name,
  isActive: payload.is_active,
  isSuperuser: payload.is_superuser,
  isVerified: payload.is_verified,
  organizationId: payload.organization_id,
  role: payload.role
    ? {
        id: payload.role.id,
        name: payload.role.name,
        description: payload.role.description,
        scope: payload.role.scope,
        organizationId: payload.role.organization_id,
      }
    : null,
  sites: payload.sites.map((site) => ({
    id: site.id,
    name: site.name,
    slug: site.slug,
    isActive: site.is_active,
    organizationId: site.organization_id,
  })),
  defaultSiteId: payload.default_site_id,
})
